export const userAgent =
  typeof window === 'undefined' ? '' : navigator.userAgent;

// ArcSite UA
// example: ArcSite@1.2.3
export const ARCSITE_REG = /ArcSite@([\d.]+)?/i;

export const mobilePattern = /mobile|mobi|wap|simulator|iphone|android/gi;
export const ardVersionPattern = /Android\s+([\d.]+);/i;
export const iosPattern = /(iphone|ipod|ipad)/i;

// 2025 promotion，到期后记得删除相关代码
export const FREE_IPAD_PROMOTION_START_TIME = '2025-12-01T08:00:00-05:00';
export const FREE_IPAD_PROMOTION_END_TIME = '2026-01-09T23:59:59-05:00';
